"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/fax-cover-page`;
    }
    /**
     * Returns fax cover pages available for the current extension.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/dictionary/fax-cover-page
     * Rate Limit Group: Light
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map